import { render, staticRenderFns } from "./HeaderTitle.vue?vue&type=template&id=6d400863&"
import script from "./HeaderTitle.vue?vue&type=script&lang=js&"
export * from "./HeaderTitle.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTitle.vue?vue&type=style&index=0&id=6d400863&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports